module.exports = __webpack_public_path__ + "media/okaloosaislandpier.0e62a957.mp4";